<form [formGroup]="form" (ngSubmit)="login()" layout="col" layoutGap="2">
    <div >
        <div layout="col" layoutAlign="center center" layoutGap="2" class="credential-wrapper">
            <p-floatlabel variant="on" [style]="{'width': '100%'}">
                <input id="email" autocomplete="username" formControlName="email" name="email" type="email" inputmode="email" pInputText style="width: 100%;" />
                <label for="email">{{'Email' | translate}}</label>
            </p-floatlabel>

            <p-floatlabel variant="on" [style]="{'width': '100%'}">
                <input id="password" name="password"  formControlName="password" autocomplete="current-password" pInputText type="password" fluid />
                <label for="password">{{'Password' | translate}}</label>
            </p-floatlabel>
        </div>

        <button type="submit" (click)="login()" style="display: none"></button>
    </div>

    <div>
        @if (auth.loginError$ | async) {
        <p-message severity="error">{{getFirebaseAuthErrorMessage(auth.loginError$ | async)}}</p-message>
        }
        @if (auth.userLoadingError$ | async) {
        <p-message severity="error">{{getBackendAuthErrorMessage(auth.userLoadingError$ | async)}}</p-message>
        }
    </div>

    <div layout="col" layoutAlign="center center">
        <p-button [label]="'Forgot Password?' | translate" [routerLink]="['../forgot-password']" type="submit" link></p-button>
    </div>

    <p-button type="submit" [style]="{'width': '100%'}" [loading]="auth.userLoading$ | async" (click)="login()">{{'Login' |
        translate}}</p-button>

    <div layout="row" layoutAlign="center center">
        <hr style="flex: 1; margin: 0 10px">
        {{'OR' | translate}}
        <hr style="flex: 1; margin: 0 10px">
    </div>

    <div layout="col" layoutGap="2">
        <p-button icon="pi pi-google" [label]="'Google' | translate" severity="secondary" (click)="socialLogin('google')" fluid></p-button>
        <!-- <p-button icon="pi pi-facebook" [label]="'Facebook' | translate" severity="secondary" fluid></p-button>
        <p-button icon="pi pi-apple" [label]="'Apple' | translate" severity="secondary" fluid></p-button> -->
    </div>

    <div layout="row" layoutAlign="center center" layoutGap="0">
        <span>{{'Don\'t have an account?' | translate}}</span>

        <p-button [label]="'Sign up' | translate" [routerLink]="['../register']" link>
        </p-button>
    </div>
</form>